export default "__VITE_ASSET__daf5860a__"